<template lang="pug">
page-layout#agreement(:heading='heading' :num-of-slide-outs='1' :class='{ "above-side-nav" : agreementPageState === "opened" }')
	.link-container(slot='link-container')
		// ? getting rid of the map reference since link leads no where.
		//- router-link.map(to='/app/map') View on Map
		//- a.alter(href='#') Alter Entry Settings
		.button(@click='agreementForm') Create New Agreement

	agreement-slide-out(
		slot='slideout-1'

		:state='agreementPageState'
		:data-state='dataState'
		:asset='activeAgreement'
		:asset-key='agreementsKey'
		asset-name='agreements'

		@close='agreementPageState = "closed"; activeAgreement = null;'
		@edit='editAgreement'
		@delete='deleteAgreement'
	)

	asset-table(
		slot='content'

		asset-name='agreements'
		asset-key='agreementsKey'
		search-text='Search for an Agreement'

		:config='config'
		:get-all='GetAgreements'
		:get='GetAgreement'
		:search='SearchAgreements'
		:download-csv='DownloadAgreementsCSV'
		:download-pdf='DownloadAgreementsPDF'

		@row-clicked='viewAgreement'
	)
</template>

<script>
import AssetTable from '@/components/AssetTable';
import PageLayout from '@/components/PageLayout';
import ButtonExpand from '@/components/ButtonExpand';
import AgreementSlideOut from '@/components/slide-outs/agreements';

import {
	GetAgreements,
	GetAgreement,
	DeleteAgreement,
	DownloadAgreementsCSV,
	DownloadAgreementsPDF,
	SearchAgreements
} from '@/lib/API';

import Submit from '@/lib/Submit';

import { editAgreement } from '@/lib/generate';

import AgreementsConfig from '@/lib/assets/agreements';
// eslint-disable-next-line no-unused-vars
import { clone } from '@/lib/utils';

export default {
	name : 'agreements',

	data : () => ( {

		heading : {
			title       : 'Agreements',
			description : 'Click any row to view the record in full',
		},

		config : {
			columns         : AgreementsConfig.columns,
			dropdownOptions : AgreementsConfig.dropdownOptions,
		},

		agreementPageState : 'closed',
		dataState          : 'loaded',
		activeAgreement    : null,
		agreementsKey      : null,

		GetAgreements,
		GetAgreement,
		DownloadAgreementsCSV,
		DownloadAgreementsPDF,
		SearchAgreements
	} ),

	created() {
		const { query } = this.$route;
		const { key }   = query;

		if ( key ) {
			this.viewAgreement( { agreementsKey : key } );
		}
	},

	methods : {

		agreementForm() {

			this.$store.dispatch( 'form', {
				type : 'agreements',
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Creating Agreement...',
						state   : 'loading'
					} );

					Submit.agreement( form )
						.then( () => form.close() )
						.then( () => stateIndicator.resolve( 'Created Successfully' ) )
						.catch( () => {
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Create Agreement', message : '' } );
						} );

				} );

		},

		viewAgreement( clicked ) {
			const { agreementsKey } = clicked;

			this.activeAgreement = null;
			this.agreementKey    = null;

			this.agreementPageState = 'opened';
			this.dataState          = 'loading';

			const displayStateOptions = {
				message        : 'Loading Agreement',
				successMessage : 'Agreement Loaded',
				failMessage    : 'Agreement could not be loaded.',
				state          : 'loading',
			};

			this.$store.dispatch( 'loadWithDisplayState', {
				options : displayStateOptions,
				method  : () => GetAgreement( agreementsKey ),
			} )
				.then( ( agreement ) => {
					this.activeAgreement = agreement;
					this.agreementsKey   = agreement.agreementsKey;
					this.dataState       = 'loaded';
					// console.log( 'success' );
				} )
				.catch( () => {
					// console.log( 'error' );
					this.dataState = 'failed';
				} );

		},

		closeAgreement() {
			this.agreementPageState = 'closed';
			this.activeAgreement    = null;
		},

		editAgreement() {
			const { agreementsKey, location } = this.activeAgreement;

			if ( location ) this.activeAgreement.locationDescription = location.description;
			else this.activeAgreement.locationDescription = ' ';

			if ( this.activeAgreement.location ) delete this.activeAgreement.location;

			const startingData = editAgreement( this.activeAgreement );

			this.$store.dispatch( 'form', {
				type : 'agreements',
				args : [{ edit : true }],
				startingData,
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Editing Agreement...',
						state   : 'loading'
					} );

					form.close();

					// Submit will take care of the displayStates.
					Submit.editAgreement( form, agreementsKey )
						.then( () => form.close() )
						.then( () => this.viewAgreement( {
							agreementsKey
						} ) )
						.then( () => stateIndicator.resolve( 'Edited Successfully' ) )
						.catch( ( error ) => {
							// console.log( error );
							console.error( error );

							stateIndicator.fail( { header : 'Didn\'t Edit Agreement', message : '' } );
						} );
				} )
				.catch( ( e ) => {
					// console.log( e );
					throw new Error( e );
				} );

		},

		async deleteAgreement() {

			const stateIndicator = await this.$store.dispatch( 'displayState', {
				message : 'Deleting Agreement...',
				state   : 'loading'
			} );

			DeleteAgreement( this.activeAgreement.agreementsKey )
				.then( () => stateIndicator.resolve( 'Deleted Successfully' ) )
				.then( this.agreementPageState = 'closed' )
				.catch( ( err ) => {

					console.error( err );

					stateIndicator.fail( { header : 'Didn\'t Delete Agreement', message : '' } );

				} );

		},

	},

	components : {
		PageLayout,
		ButtonExpand,
		AgreementSlideOut,
		AssetTable,
	}

};
</script>

<style lang="scss">

.space-form.agreements-form {
	@include set-form-color( #BAB180 );

	.drop-box-wrapper .background {
		background: lighten( #BAB180, 30% );
	}


	.form-label {
		text-align: center;
		font-weight: 500;
	}
}

#agreement {

	td.agreement-type {

		.content {
			width: 400px !important;
		}
	}
}
</style>
